var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 226.8 226.8",
    height: 226.8,
    viewBox: "0 0 226.8 226.8",
    width: 226.8,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_2_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_3_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_4_"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_5_"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_6_"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_7_"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_8_"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_9_"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#a6ce39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.7 112.6 10 2.2c1.1-9.8 5.3-45.3-25.5-87 .1 0 24.5 40.2 15.5 84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.8 141.5-9.1 4.7c-3.6-9.2-17.1-42.3 1.5-90.6 0 .1-13 45.4 7.6 85.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.6 95-10 2.3c-1.2-9.8-6-45.3 24.2-87.3 0 0-23.9 40.6-14.2 85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.5 109-9.1 4.7c-3.6-9.2-17.1-42.3 1.5-90.6 0 .1-12.9 45.4 7.6 85.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m130.6 57.7-74.3 35.6 25.6 58.3 40.9 15.2 38.3-23.9 7.8-30.9z",
    fill: "#928671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.1 61.6 73.5-3.9-74.3 35.6-22.2-9.5z",
    fill: "#afa591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.1 173.8s-19.1 1.3-13.5-32.2c5.7-33.5 20.4-57.8 20.4-57.8l22.2 9.6 25.7 58.3-51.3 47-9.1-11.7z",
    fill: "#3f3321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.1 198.1-5.2-46.5-51.3 47s20.4 7.8 30.4 7.8 26.1-8.3 26.1-8.3z",
    fill: "#695f4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.9 216.8 10.8-28.7-13.9-21.3-40.9-15.2 5.2 46.5z",
    fill: "#1d160d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.3 190.3-33.5 20-46.9 6.5 10.8-28.7 30.9-25.2z",
    fill: "#3f3321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.8 104.2-32.2 58.7 38.7 27.4s11.7-43 6.5-60.4-13-25.7-13-25.7z",
    fill: "#928671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.6 57.7 69.2 46.5-32.2 58.7-6.5-20 7.8-30.9z",
    fill: "#afa591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.8 166.8 13.9 21.3 30.9-25.2-6.5-20z",
    fill: "#695f4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.2 204 10.5 5.1c1.1-9.8 4.8-48.2-25.9-89.9 0 0 24.5 40.2 15.4 84.8z",
    fill: "#a6ce39"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_10_"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_11_"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_12_"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_13_"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_14_"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_15_"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_16_"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_17_"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_18_"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_19_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStone);
export default __webpack_public_path__ + "static/media/stone.bbee1a90b66e54843a8d3484e406888b.svg";
export { ForwardRef as ReactComponent };